<template>


    <div></div>

</template>

<script>
    import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";

    export default {
        name: "Coupons",
        mounted(){
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Купоны" }]);
        },
    }
</script>

<style scoped>

</style>